export type ActiveNavTab = "map" | "sites" | "workspaces" | "dashboard" | "account" | "share";

export function getActiveNavTab(pathname: string): ActiveNavTab {
  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const normalized = path === "/" ? path : path.replace(/\/$/, "") || "/";

  if (normalized === "/workspaces" || normalized.startsWith("/workspaces/")) {
    return "workspaces";
  }
  if (normalized === "/sites" || normalized.startsWith("/sites/")) {
    return "sites";
  }
  if (normalized === "/dashboard" || normalized.startsWith("/dashboard/")) {
    return "dashboard";
  }
  if (normalized === "/account" || normalized.startsWith("/account/") || normalized.startsWith("/logout")) {
    return "account";
  }
  if (normalized === "/share" || normalized.startsWith("/share/")) {
    return "share";
  }
  if (normalized === "/" || normalized === "/map" || normalized.startsWith("/map/")) {
    return "map";
  }
  return "map";
}
